import { render } from "./MLFang.vue?vue&type=template&id=3a8eff4c&scoped=true"
import script from "./MLFang.vue?vue&type=script&lang=js"
export * from "./MLFang.vue?vue&type=script&lang=js"

import "./MLFang.vue?vue&type=style&index=0&id=3a8eff4c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8eff4c"]])

export default __exports__